import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h6", { class: "q-ma-none" }, "Bekräfta", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "q-ml-sm" }, "Är du säker på att du vill skapa en avställning bakåt i tiden?", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_section, { class: "row items-center" }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_actions, { align: "right" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_btn, {
            flat: "",
            label: "Stäng",
            onClick: _ctx.closeModal
          }, null, 8, ["onClick"]),
          _createVNode(_component_q_btn, {
            flat: "",
            label: "Bekräfta",
            color: "primary",
            onClick: _ctx.confirm
          }, null, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}